import getLabelFromUnderscoreString from '../domains/Content/utils/getLabelFromUnderscoreString';



const getImageTypeOptions = (imageTypes = []) => imageTypes.map((item) => {
  return {
    label: getLabelFromUnderscoreString(item),
    value: item,
  };
});


export default getImageTypeOptions;
